import { createField } from "./health-cert.section";

export const initForm = ({ props, data, refs }) => {
    const key = props.dataKey;
    const isLoading = props.isLoading;
    data.fields = createField({ props, data, refs, key, isLoading });
};
